import React from 'react';
import { BrowserRouter, Routes, Route} from 'react-router-dom';
import Home from './Pages/Home/Home';
import './App.scss'
import Login from './Common/Login/Login';
import Register from './Common/Register/Register';
import Loader from './Common/Loader/Loader';
import Provider from './Common/Context/Provider';
import Alert from './Common/Alert/Alert';
import Work from './Common/Work/Work';
import Stt from './Common/Stt/Stt';
import Header from './Common/Header/Header';
import Sidebar from './Common/Sidebar/Sidebar';
import Gtt from './Common/Gtt';
import Projects from './Common/Projects/Projects';
import Learning from './Common/Learning/Learning';
import WorkCompleted from './Common/WorkCompleted/WorkCompleted';
import NoPage from './Common/NoPage/NoPage';
import Right from './Common/Right/Right';
import Am from './Common/Am/Am';
import Profile from './Common/Profile/Profile';
import Report from './Common/Report/Report';
import Certificate from './Common/Certificate/Certificate';
import Timeline from './Common/Timeline/Timeline';
import LogoutModel from './Common/LogoutModel/LogoutModel';


const App = () => {

  return (
    <BrowserRouter>
      <Provider>
  
        <Header/>
    <LogoutModel/>
        <Loader />
        <Am/>
        <Stt/>
          <Alert />
<Gtt/>

        <div className='main-main'>

   <Sidebar/>

  
 <div className='main-route'>
 
    <Routes>
  
    <Route path='/login' element={<Login />} />
    <Route path='*' element={<NoPage/>} />
    <Route path='/register' element={<Register />} />
    <Route path='/profile' element={<Profile />} />
    <Route path='/' element={<Home />} />
    <Route path='/reports' element={<Report />} />
    <Route path='/work-completed' element={<WorkCompleted/>} />
    <Route path='/projects' element={<Projects/>} />
    <Route path='/learning' element={<Learning/>} />
    <Route path='/intern' element={<Work />} />

<Route path="/certificate" element={<Certificate/>} />
<Route path="/timeline" element={<Timeline/>} />

    
 
  </Routes>

  </div>

<Right/>

    
    
    
    </div>
  


   
       
      </Provider>
    </BrowserRouter>
  );
};

export default App;
